import useWindowDimensions from "@/hooks/useWindowDimensions";

import MobileHeader from "./MobileHeader";

const PanelTitle = ({ title, children }: { title?: string; children?: React.ReactNode }) => {
    const { size } = useWindowDimensions();

    return (
        <>
            {/* Mobile Header */}
            <MobileHeader />

            {/* Desktop Title */}
            <div className="hidden md:grid md:grid-cols-12 text-slate-600 pt-2 p-4 px-[30px] md:p-8 md:pb-2 md:pt-2 md:gap-4 gap-2 select-none">
                <div className="col-start-1 col-span-12 md:col-span-6 flex gap-2">
                    <h1 className="text-2xl font-bold mb-0 mt-0 flex gap-2 items-center justify-between w-full">
                        <div className="flex gap-2 items-center">{size.md && title}</div>
                    </h1>
                </div>
                {children}
            </div>
        </>
    );
};

export default PanelTitle;
